import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const MatasPlusDisclaimerQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
}>({
    isOpen: false
});

export default function useMatasPlusDisclaimerQuickView() {
    return useMediatorState(MatasPlusDisclaimerQuickViewAtom);
}
